




























import Vue, { PropType } from 'vue';
import StateEnum from '~/utils/StateEnum';
import { isValid, isAfter, format } from 'date-fns';

// Services
import { CandidateStudyProgram } from '~/services/CSPService';

// Components

interface CSP extends CandidateStudyProgram {
    enumKey: number;
}

export default Vue.extend({
    name: 'StudyProgramListItem',
    props: {
        csp: {
            type: Object as PropType<CSP>,
            required: true,
        },
        hasChanged: {
            type: Boolean,
            default: () => false,
            required: false,
        },
    },
    computed: {
        schoolTitle(): string {
            if (this.csp.studyProgram.school) {
                return this.csp.studyProgram.school.name;
            }
            return this.csp.studyProgram.customSchoolName || '';
        },
        schoolLogo(): string {
            if (this.csp.studyProgram.school) {
                return this.csp.studyProgram.school.logo;
            }
            return '';
        },
        studyProgramTitle(): string {
            return this.csp.studyProgram.name || '';
        },
        studyField(): string {
            if (this.csp.studyProgram.fields && this.csp.studyProgram.fields.length > 0) {
                return this.csp.studyProgram.fields[0].name;
            }
            return '';
        },
        studyLevel(): string {
            if (this.csp.studyProgram.level) {
                return this.csp.studyProgram.level.name;
            }
            return '';
        },
        graduationDate(): Date {
            return this.csp.end;
        },
        graduationText(): string {
            const graduationDate = new Date(this.graduationDate);
            if (!isValid(graduationDate) || isAfter(graduationDate, new Date())) {
                return this.$t('spotlight.education.notGraduated') as string;
            }
            return this.$t('spotlight.education.graduatedIn', {
                date: format(graduationDate, 'MMM yyyy'),
            }) as string;
        },
        state(): number {
            if (this.hasChanged) {
                return StateEnum.UNSAVED;
            }
            return StateEnum.SUCCESS;
        },
        enumKey(): string {
            return Object.keys(StateEnum)[this.state] || '';
        },
    },
    methods: {
        onEdit() {
            this.$emit('onEdit');
        },
    },
});
